import React from 'react';
import { useTranslation } from 'react-i18next';
import { Database, Globe } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export type SourceType = 'all' | 'web';

interface ChatSourceSelectProps {
  value: SourceType;
  onChange: (value: SourceType) => void;
  disabled?: boolean;
}

/** Chooses what the next question may draw on; 'web' sets includeWebSearch. */
const ChatSourceSelect: React.FC<ChatSourceSelectProps> = ({ value, onChange, disabled }) => {
  const { t } = useTranslation();

  return (
    <Select value={value} onValueChange={(next) => onChange(next as SourceType)} disabled={disabled}>
      <SelectTrigger
        aria-label={t('chat.allSources')}
        className="h-7 w-auto gap-1 border-transparent px-2 text-xs shadow-none hover:bg-accent focus:ring-0"
      >
        <SelectValue />
      </SelectTrigger>

      <SelectContent className="revy-ui">
        <SelectItem value="all">
          <span className="flex items-center gap-1.5">
            <Database className="size-4" strokeWidth={1.8} />
            {t('chat.allSources')}
          </span>
        </SelectItem>
        <SelectItem value="web">
          <span className="flex items-center gap-1.5">
            <Globe className="size-4" strokeWidth={1.8} />
            {t('chat.webOnly')}
          </span>
        </SelectItem>
      </SelectContent>
    </Select>
  );
};

export default ChatSourceSelect;
